import { Expose } from 'class-transformer';
import { Point } from 'geojson';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { SnContentType, getContentTypeIcon } from '../base';

export class SnSearchItem extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public contentType: SnContentType;

  @Expose()
  public label: string;

  @Expose()
  public secondaryLabel: string;

  @Expose()
  public attributes?: any;

  @ExposeRawData()
  public geometry: Point;

  constructor(data: any) {
    super();

    this.fromJSON(data);
  }

  get coords(): { lng: number; lat: number } {
    if (!this.geometry) {
      return;
    }

    return {
      lng: this.geometry.coordinates[0],
      lat: this.geometry.coordinates[1],
    };
  }

  get icon(): string {
    return getContentTypeIcon(this.contentType);
  }
}
